import { createApi } from '@reduxjs/toolkit/query/react';
import { authBaseQuery } from '../utils/authBaseQuery';

const baseUrl =
  process.env.NEXT_PUBLIC_USE_SECURITY === 'true'
    ? process.env.NEXT_PUBLIC_API_SECURITY
    : process.env.NEXT_PUBLIC_API_CHECKOUT;

export const checkoutApi = createApi({
  reducerPath: 'checkoutApi',
  baseQuery: authBaseQuery({
    baseUrl,
    timeout: 30000,
  }),
  keepUnusedDataFor: 0,
  tagTypes: ['Checkout'],
  endpoints: (builder) => ({
    confirmChallenge: builder.mutation({
      query: ({ id, gateway, challengeStatus }) => ({
        url: `payment-methods-command/api/v1/status/${challengeStatus}/order/${id}/payment-method/${gateway}`,
        method: 'POST',
        keepalive: true,
      }),
      invalidatesTags: ['PaymentMethods'],
    }),
    generateOrder: builder.mutation({
      query: (data) => ({
        url: 'bookings-core/api/v1/bookings/generate-booking',
        method: 'POST',
        body: data.body,
        headers: {
          ...(data.link ? { link: data.link } : {}),
          ...(data.recaptchaToken
            ? { 'x-recaptcha-token': data.recaptchaToken }
            : {}),
        },
      }),
      providesTags: ['Order'],
    }),
    payOrder: builder.mutation({
      query: (data) => ({
        url: 'bookings-core/api/v1/bookings/generate-payment',
        method: 'POST',
        body: data.body,
        headers: {
          ...(data.link ? { link: data.link } : {}),
        },
      }),
    }),
    verifyPaymentStatus: builder.mutation({
      query: (id) => ({
        url: `bookings-core/api/v1/bookings/verify-status/${id}`,
        method: 'GET',
      }),
    }),
    getBookingInfo: builder.mutation({
      query: (body) => ({
        url: 'bookings-core/api/v1/bookings/information',
        method: 'POST',
        body,
      }),
    }),
    changeStatus: builder.mutation({
      query: (body) => ({
        url: 'bookings-core/api/v1/bookings/change-status',
        method: 'PUT',
        body,
      }),
    }),
    generateBookingsPdf: builder.mutation({
      query: (body) => ({
        url: 'checkout-bookings-broker/api/v1/generate-bookings-pdf',
        method: 'POST',
        body,
      }),
    }),
    getPaymentMethods: builder.query({
      query: (id) => `events-core/api/v1/events/${id}/payments`,
    }),
    releaseBooking: builder.mutation({
      query: (booking) => ({
        url: `bookings-core/api/v1/bookings/release`,
        method: 'POST',
        body: {
          booking_number: booking,
        },
      }),
    }),
  }),
});

export const {
  useConfirmChallengeMutation,
  useGenerateOrderMutation,
  useGetBookingInfoMutation,
  useChangeStatusMutation,
  usePayOrderMutation,
  useVerifyPaymentStatusMutation,
  useGenerateBookingsPdfMutation,
  useGetPaymentMethodsQuery,
  useReleaseBookingMutation,
} = checkoutApi;
